import { Table, TableBody, TableContainer } from "@mui/material"
import { RolesTableHead } from "./roles-table-head"
import { dataFromEdges } from "lib/permissions/helpers"
import { getAllocateableRoleDemands } from "lib/permissions/demands"
import { UserRolesTableGroup } from "./UserRolesTableGroup"

export function RolesTable({ queryResults, selectableDemands }) {
    const roles = dataFromEdges(queryResults)

    const defaultDemands = getAllocateableRoleDemands.useResults()
    const demands = selectableDemands ?? defaultDemands
    if (!roles?.length) return null
    if (!demands?.length) return null

    const groups = demands.groupBy("group")

    return (
        <TableContainer>
            <Table size="small" sx={{ tableLayout: "fixed" }} data-cy="client-admin-roles-table">
                <RolesTableHead demands={demands} roles={roles} />
                {roles.length > 0 && (
                    <TableBody>
                        {Object.keys(groups).map((group, gix) => (
                            <UserRolesTableGroup key={`tl-${gix}`} groups={groups} groupKey={group} roles={roles} />
                        ))}
                    </TableBody>
                )}
            </Table>
        </TableContainer>
    )
}
